export default "__VITE_ASSET__CKPG0Nyr__"